import { Fragment, SVGProps } from "react";

type TSVGIconsProps = {
	icon: "les-bordes-logo";
} & SVGProps<SVGSVGElement>;

function SVGIcons(props: TSVGIconsProps) {
	const { icon, fill = "black", stroke= "black", strokeWidth = 1, ...rest } = props;
	return (
		<svg viewBox="0 0 100 100" x="0px" y="0px" {...rest}>
			{icon === "les-bordes-logo" && (
				<g id="les-bordes">
					<path
						d="M10,68c-.5,0-1-.4-1-.9s.4-1,.9-1c.5,0,1,.4,1,.9,0,0,0,0,0,0,0,.5-.3.9-.8,1,0,0,0,0,0,0ZM10,65.4c-.9,0-1.6.7-1.6,1.6s.7,1.6,1.6,1.6,1.6-.7,1.6-1.6-.7-1.6-1.6-1.6Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="12.6 68.7 13.4 68.7 13.4 65.5 12.6 65.5 12.6 68.7 12.6 68.7"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="83.1 65.4 82.4 65.4 82.4 68.6 84.9 68.6 84.9 67.9 83.1 67.9 83.1 65.4 83.1 65.4"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M56.7,60c-.3,0-.5-.5-.4-.9,1.7-4.8,4.9-7.8,8.7-8.5h0c.6.3,1.2.4,1.9.4-.3.7-.7,1.4-1.1,2-2.6,3.7-5.8,7.3-9.1,6.9h0ZM50.4,64.5c-.3.3-.5.1-.5-.4.2-7.3,2.3-13,7.3-16.9.2-.2.5,0,.5.3.4,5.9-2.9,12.9-7.3,16.9h0ZM47.8,64.5c-4.3-4-7.6-11-7.3-16.9,0-.3.3-.5.5-.3,5,3.8,7,9.6,7.3,16.9,0,.5-.2.7-.5.4h0ZM41.5,60c-3.3.4-6.5-3.2-9.1-6.9-.2-.4-.5-.7-.7-1.1.5-.4.9-.8,1.2-1.4,4,.7,7.3,3.6,9,8.6.1.4,0,.8-.4.9h0ZM67.4,61.4c-2.2.2-4.4-.4-6.6-1.6,1.5-1.6,3-2.9,4.7-3.5,1.1-.4,2.4-.5,3.5-.7,0-.2-.1-.3-.2-.5-.8,0-1.7.2-2.5.2-.4,0-.7-.5-.5-.9.4-1,.9-1.6,1.5-3.1h0c1.2-.2,2.6-.9,3.6-3.2-2.8-1.1-4.4.2-5.2,1.4.9,0,1.9.2,3-.2,0,0,.1,0,.2,0,0,0,0,.1,0,.2-1.9.8-2.7.6-3.5.6h0c-.9.1-1.8.3-2.6.7.4-.7.8-1.4,1.2-2.2h0s2.6-2.6,0-5.7c-1.8,2.1-1.2,4-.6,5-1.2,2.4-3.1,4.4-5.2,6-.2.2-.5,0-.5-.3,0-2.4.3-4.8,1-7.1,1.3-.9,3.5-3.2,2-7.4-3.1,1.6-3.5,4.1-3.4,5.9-.8,1.5-1.8,2.9-3,4-.3.3-.6.5-.9.8-.4.3-1,0-1-.7,0-2.9.4-5.5,1.4-7.9.2,0,3.2,0,3.3-3.8-1.9.1-2.7,1.3-3.1,2.2-.6,1.2-1,2.5-1.6,3.6-.6-2-.4-1.2-.7-2.7l-.4-.9h0c-.3-.7-.7-1.5-1.1-2.1,0-.1,0-.3.2-.1.8,1.1,1.2,1.8,1.5,2.3.2-1.4-.1-3.6-2.7-5-1.5,4.4,1.8,6.2,2.3,6.4.9,4.3.9,9.4-.7,13.4-.6,1.5-1.1,3-1.4,4.6-.1.5-.2,1-.3,1.4-.1-.5-.2-.9-.3-1.4-.3-1.6-.8-3.1-1.4-4.6-1.8-4.6-1.6-10.5-.3-15.2.1-.4,0-.8,0-1.1h0c-.3,1.5-.8,3-1.4,5-.5-1-.9-2.1-1.4-3.2,0-.6-.3-3.6-3.6-3.7.2,3.1,2.3,3.7,3.2,3.8,1.3,2.7,1.9,5.7,1.9,9s-.6,1.1-1,.7c-.3-.3-.6-.5-.9-.8-1.2-1.1-2.1-2.4-2.9-3.8.1-1.7-.3-4.9-4.1-6.2-.8,3.8,1,5.8,2.4,6.7.9,2.4,1.3,5,1.3,7.8,0,.4-.2.5-.5.3-1.8-1.3-3.4-3-4.6-4.9h0c-.2-.3-.6-1.1-1-2.1l-.4-.9c-.1-.3-.3-.7-.4-1.1,0,0,0-.1,0-.2s.1,0,.2,0c.5,1.1,1.1,2.1,1.8,3.1.2-1.4,0-3.7-2.7-5.1-1.2,3.3.5,5.1,1.5,5.9.3.7.7,1.3,1.1,1.9-.8-.3-1.7-.6-2.6-.7-.8-.3-3.3-1.1-4.7,2,1.3.6,2.3.5,3,.2.4.8.7,1.3,1,2.1.2.4,0,1-.5.9-.8,0-1.7-.2-2.5-.2,0,.2-.1.3-.2.5,1.2.2,2.4.3,3.5.7,1.7.6,3.3,1.9,4.7,3.5-2.6,1.4-5.1,2-7.7,1.5h0c-.7-.3-1.6-.4-3-1.9,0,0,0-.1,0-.2,0,0,.1,0,.2,0,.9.8,1.9,1,2.7,1.4-.3-1.4-1.3-3.6-4.4-3.7.2,2.8,1.6,4,2.8,4.5h0c.4.2.9.4,1.4.5,2.2.3,4.4.1,6.4-.6,2.5-.8,5-1,7.4.6l.2.2c.9.7,4.5,3.3,4.5,6h0c0,.2.2.4.4.5l.9.5.9-.6c.2,0,.3-.3.3-.5h0c0-.1,0-.2,0-.2.2-2.7,3.6-5.2,4.5-5.8l.2-.2c2.4-1.5,4.9-1.4,7.4-.6,2.1.7,4.3.9,6.4.6.3,0,.7-.2,1-.3,1.1-.3,2.4-1.2,3.1-3.4-4.3-1.1-5.4,2.9-5.6,3.3h0Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="94.2 65.4 93.4 66.6 92.5 65.4 91.6 65.4 93 67.3 93 68.6 93.7 68.6 93.7 67.3 95 65.4 94.2 65.4 94.2 65.4"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="19.3 67.3 20.5 67.3 20.5 66.7 19.3 66.7 19.3 66.1 21.2 66.1 21.2 65.5 18.6 65.5 18.6 68.7 21.4 68.7 21.4 68 19.3 68 19.3 67.3 19.3 67.3"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="86.2 65.4 85.5 65.4 85.5 68.6 88 68.6 88 67.9 86.2 67.9 86.2 65.4 86.2 65.4"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="89.3 67.3 90.4 67.3 90.4 66.6 89.3 66.6 89.3 66.1 91.1 66.1 91.1 65.4 88.6 65.4 88.6 68.6 91.3 68.6 91.3 68 89.3 68 89.3 67.3 89.3 67.3"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M79.6,67.4l.5-1.1.5,1.1h-.9ZM79.7,65.4l-1.3,3.2h.7l.2-.6h1.4l.2.6h.8l-1.3-3.2h-.7Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="78 65.4 77.1 67.7 76.2 65.4 75.4 65.4 76.7 68.6 77.5 68.6 78.7 65.4 78 65.4 78 65.4"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M51.6,82.5l1.1-2.4,1.1,2.4h-2.2ZM52.2,78.7l-2.7,6h1.1l.5-1.2h3l.5,1.2h1.2l-2.7-6h-1.1Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="56.4 79.8 58.7 79.8 58.7 84.8 59.9 84.8 59.9 79.8 62.3 79.8 62.3 78.8 56.4 78.8 56.4 79.8 56.4 79.8"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="31.4 82.1 33.6 82.1 33.6 81.1 31.4 81.1 31.4 79.7 35.1 79.7 35.1 78.8 30.2 78.8 30.2 84.8 35.4 84.8 35.4 83.8 31.4 83.8 31.4 82.1 31.4 82.1"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="65 82.1 67.3 82.1 67.3 81.1 65 81.1 65 79.7 68.8 79.7 68.8 78.8 63.9 78.8 63.9 84.8 69.1 84.8 69.1 83.8 65 83.8 65 82.1 65 82.1"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="43.3 79.8 45.6 79.8 45.6 84.8 46.8 84.8 46.8 79.8 49.2 79.8 49.2 78.8 43.3 78.8 43.3 79.8 43.3 79.8"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M40,81.2c-.4,0-.7,0-1.1-.1-.6,0-1-.3-1-.7s.4-.7,1.2-.7,1.4.4,1.6.7h1.2c-.2-.8-.9-1.6-2.8-1.6s-2.4.6-2.4,1.7.9,1.6,2,1.8h1.1c.6.2,1,.4,1,.9s-.5.8-1.4.8-1.6-.5-1.7-.9h-1.2c.2.9,1,1.8,2.9,1.8s2.5-.8,2.5-1.9-.9-1.7-2.1-1.8h0Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M72,22.7l1.5,1c1.5,1,1.9,2.5.9,4.1s-2.6,1.7-4.1.7l-1.5-1,3.2-4.8h0ZM69.5,29.7c2.3,1.6,4.7,1.2,6.3-1s.9-4.6-1.4-6.2l-2.9-2-4.9,7.2,2.9,2Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M48,19.4c0-1.6,1.3-2.9,3-2.8s2.8,1.5,2.7,3.1-1.3,2.9-3,2.8-2.8-1.5-2.7-3.1h0ZM50.6,24c2.6.1,4.6-1.6,4.8-4.2s-1.7-4.6-4.3-4.7-4.6,1.6-4.8,4.2,1.7,4.6,4.3,4.7h0Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M61.1,18.1l2.9,1c.9.3,1.2.8,1,1.5-.2.7-.8.9-1.7.6l-2.9-1,.7-2.1ZM59.9,21.5l2.6.9.7,4,1.6.6-.7-4.2c1.1,0,2.1-.6,2.4-1.7.5-1.6-.2-2.8-2-3.4l-4.6-1.5-2.8,8.2,1.5.5,1.1-3.4h0Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M25.1,27.6l1.4-.7c.8-.4,1.5-.5,1.9.2.4.6,0,1.4-1,2.1-1.3.9-2.3.7-2.8.3l-1.5,1c.9.8,2.7,1.4,5-.1,2-1.3,2.4-3,1.6-4.3-1-1.5-2.5-1.3-4-.5-.5.3-.9.5-1.4.7-.8.4-1.4.4-1.7,0s0-1.2.9-1.8c1.2-.8,2-.6,2.5-.4l1.4-.9c-.8-.8-2.4-1.3-4.6.2-1.7,1.1-2.4,2.7-1.5,4s2.3,1.3,3.9.5h0Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M89.1,42.8l.8,1.5c.9-.8,1.5-2.3.2-4.6-1-1.8-2.5-2.6-3.8-1.9s-1.5,2.2-.8,3.8l.6,1.4c.3.8.4,1.5-.3,1.9-.6.3-1.4,0-2-1.2-.7-1.4-.4-2.3,0-2.8l-.8-1.5c-.9.9-1.7,2.5-.3,5,1.2,2.2,2.7,2.7,4.1,2,1.6-.9,1.6-2.4.9-4-.2-.5-.4-.9-.6-1.4-.3-.9-.3-1.5.2-1.7s1.2,0,1.8,1.1c.7,1.3.5,2.1.2,2.5h0Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M39.8,17.6c.9-.2,1.4,0,1.6.8s-.2,1.1-1.2,1.3l-2.8.6-.4-2.1,2.8-.6h0ZM42.3,21.9c.2.8-.2,1.3-1.3,1.5l-2.8.6-.5-2.3,2.8-.6c1-.2,1.6,0,1.7.9ZM41.5,24.7c2-.4,2.8-1.5,2.5-3-.2-.9-.9-1.7-1.9-1.8.7-.4,1.1-1.2.9-2-.3-1.4-1.4-2.1-3.3-1.7l-4.5.9,1.7,8.5,4.6-.9h0Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="80.9 38.4 77.1 34 78.9 32.4 81 34.8 82.1 33.9 80 31.5 81.5 30.2 85 34.3 86 33.4 81.5 28 74.9 33.7 79.8 39.4 80.9 38.4 80.9 38.4"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="18.7 36.9 16.9 35.3 19.1 33 18 32 15.9 34.4 14.4 33.1 18 29.1 16.9 28.1 12.3 33.3 18.7 39.1 23.7 33.6 22.6 32.6 18.7 36.9 18.7 36.9"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="13.8 44.7 7.5 41.2 6.8 42.6 14.3 46.8 17.7 40.7 16.4 40 13.8 44.7 13.8 44.7"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<path
						d="M16.3,66.8h-1v-.7h1c.3,0,.4,0,.4.3s-.1.3-.4.3h0ZM17.5,66.5c0-.7-.4-1-1.1-1h-1.9v3.2h.8v-1.2h.9l.7,1.2h.8l-.7-1.3c.4-.1.6-.5.6-.9h0Z"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
					<polygon
						points="5.8 65.5 5 65.5 5 68.7 7.6 68.7 7.6 68 5.8 68 5.8 65.5 5.8 65.5"
						fill={fill}
            strokeWidth={strokeWidth}
            stroke={stroke}
					/>
				</g>
			)}
		</svg>
	);
}

export default SVGIcons;
